import { SvgIcon, SvgIconProps } from "@mui/joy";
import { forwardRef } from "react";

const TickedCircle = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  return (
    <SvgIcon {...props} ref={ref}>
      <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="16" height="16" rx="8" fill="#6E7891" />
        <path
          d="M11 10.4642V12H5V10.4527L8.91304 5.53582H5.19282V4H10.9093V5.54728L6.98488 10.4642H11Z"
          fill="white"
        />
      </svg>
    </SvgIcon>
  );
});

TickedCircle.displayName = "Warning";

export default TickedCircle;
